<div class="card-container" *ngFor="let card of cards; index as i;">
	<app-card [card]="card" (clicked)="cardClicked($event)"></app-card>
</div>